export default "__VITE_ASSET__CIWxxOvi__"